import CustomInput from "../lib/CustomInput";
import React, { useEffect, useState } from "react";

import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import moment from "jalali-moment";
import { Button, Form, Modal } from "react-bootstrap";
import { useMutation } from "react-query";
import { updateWomenFanCard } from "../../../api/womenFanCard/womenFanCardApi";
import { toast } from "react-toastify";

function WomenFanCardForm({
  formik,
}: {
  formik: any;
  labels: { sendBtnLabel: string };
  formType: string;
  setFormStatus: any;
  banner: any;
  filePath: any;
}) {
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [selectedId, setSelectedId] = useState("");

  const confirmReject = () => {
    updateFanCardStatus.mutate({
      id: selectedId,
      body: { status: "rejected", rejectReason: rejectReason },
    });
    setShowRejectModal(false);
    setRejectReason("");
  };

  const updateFanCardStatus = useMutation({
    mutationFn: async ({ id, body }: { id: string; body: any }) => {
      return await updateWomenFanCard(id, body);
    },
    onSuccess: () => {
      toast.success("بروزرسانی با موفقیت انجام شد");
    },
  });

  const handleReject = (id) => {
    setSelectedId(id);
    setShowRejectModal(true);
  };

  // useEffect(() => {
  //   if (formik?.values?.dateOfBirth) {
  //     console.log(formik?.values?.dateOfBirth);
  //     formik.setFieldValue(
  //       "dateOfBirth",
  //       moment(formik?.values?.dateOfBirth).format("jYYYY/jMM/jDD")
  //     );
  //   }
  // }, [formik?.values?.dateOfBirth]);

  console.log(formik?.values?.status);

  return (
    <>
      <div className={"card-body"}>
        <div className="row mb-6">
          <div className="col-6  ">
            <CustomInput
              formik={formik}
              label={"نام"}
              placeholder={"نام"}
              fieldName={"firstName"}
              disabled
            />
          </div>
          <div className="col-6  ">
            <CustomInput
              formik={formik}
              label={"نام خانوادگی"}
              placeholder={"نام خانوادگی"}
              fieldName={"lastName"}
              disabled
            />
          </div>
        </div>

        <div className="row mb-6">
          <div className="col-6  ">
            <CustomInput
              formik={formik}
              label={"کد ملی"}
              placeholder={"کد ملی"}
              fieldName={"nationalCode"}
              disabled
            />
          </div>

          <div className="col-6  ">
            <CustomInput
              formik={formik}
              label={"شماره شناسنامه"}
              placeholder={"شماره شناسنامه"}
              fieldName={"nationalNumber"}
              disabled
            />
          </div>
        </div>

        <div className="row mb-6">
          <div className="col-6  ">
            <CustomInput
              formik={formik}
              label={"تاریخ تولد"}
              fieldName={"dateOfBirth"}
              disabled
            />
          </div>
          <div className="col-6  ">
            <CustomInput
              formik={formik}
              label={"تحصیلات"}
              placeholder={"تحصیلات"}
              fieldName={"education"}
              disabled
            />
          </div>
        </div>
        <div className="row mb-6">
          <div className="col-6  ">
            <CustomInput
              formik={formik}
              label={"کد پستی"}
              placeholder={"کد پستی"}
              fieldName={"postalCode"}
              disabled
            />
          </div>

          <div className="col-6   ">
            <CustomInput
              formik={formik}
              label={"آدرس کامل"}
              placeholder={"آدرس کامل"}
              fieldName={"fullAddress"}
              disabled
              classNames={"col-6"}
            />
          </div>
        </div>

        <div className="row mb-6">
          <div className="col-6  ">
            <CustomInput
              formik={formik}
              label={"شماره تلفن"}
              placeholder={"شماره تلفن"}
              fieldName={"phoneNumber"}
              disabled
            />
          </div>
          <div className="col-6  ">
            <CustomInput
              formik={formik}
              label={"شماره موبایل"}
              placeholder={"شماره موبایل"}
              fieldName={"mobileNumber"}
              disabled
            />
          </div>
        </div>

        <div className="row mb-6">
          <div className="col-6  ">
            <CustomInput
              formik={formik}
              label={"نام پدر"}
              placeholder={"نام پدر"}
              fieldName={"fatherName"}
              disabled
            />
          </div>
          <div className="col-6 d-flex gap-10 text-center ">
            {formik?.values?.status == "pending" ? (
              <>
                <span
                  onClick={() => handleReject(formik?.values.id)}
                  style={{
                    display: "flex",
                    width: "150px",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "50px",
                    backgroundColor: "black",
                    padding: "3px",
                    color: "white",
                    cursor: "pointer",
                  }}
                >
                  رد
                </span>
                <span
                  onClick={() =>
                    updateFanCardStatus.mutate({
                      id: formik?.values.id,
                      body: { status: "accepted", rejectReason: "" },
                    })
                  }
                  style={{
                    display: "flex",
                    width: "150px",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "50px",
                    padding: "3px",
                    backgroundColor: "green",
                    color: "white",
                    cursor: "pointer",
                    marginLeft: "10px",
                  }}
                >
                  تایید
                </span>
              </>
            ) : (
              "-"
            )}
          </div>
        </div>

        <div className="row mb-6">
          <div className="d-flex flex-column col-6 gap-5 mr-5">
            <a
              href={`${process.env.REACT_APP_BASE_URL}${formik?.values?.nationalCardImage}`}
            >
              تصویر کارت ملی
            </a>
            <img
              width={"200px"}
              height={"200px"}
              src={`${process.env.REACT_APP_BASE_URL}${formik?.values?.nationalCardImage}`}
              alt=""
            />
          </div>

          <div className="d-flex flex-column col-6 gap-5 mr-5">
            <a
              href={`${process.env.REACT_APP_BASE_URL}${formik?.values.personalImage}`}
            >
              تصویر پرسنلی
            </a>
            <img
              width={"200px"}
              height={"200px"}
              src={`${process.env.REACT_APP_BASE_URL}${formik?.values?.personalImage}`}
              alt=""
            />
          </div>
        </div>

        <Modal show={showRejectModal} onHide={() => setShowRejectModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>دلیل رد درخواست</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="rejectReason">
                <Form.Label>لطفا دلیل رد را وارد کنید:</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={rejectReason}
                  onChange={(e) => setRejectReason(e.target.value)}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowRejectModal(false)}
            >
              انصراف
            </Button>
            <Button variant="primary" onClick={confirmReject}>
              تایید
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default WomenFanCardForm;
